import { useLocation } from "react-router";
import { useMemo } from "react";

// We need to define object here.
// eslint-disable-next-line @typescript-eslint/ban-types
export function useQueryParams<T extends object>(): T {
  const { search } = useLocation();

  return useMemo<T>(() => {
    const searchParams = new URLSearchParams(search);
    const resultObject: Record<string, string> = {};

    for (const [key, value] of searchParams.entries()) {
      resultObject[key] = value;
    }

    return resultObject as T;
  }, [search]);
}
